export default __webpack_public_path__ + "media/images/backgrounds/bg-14-314a20b6b866b007b8f24c2426ee4e8f.jpg";